import { ArrowRight } from "lucide-react"
import { Button } from "~/components/ui/button"

interface ServicePageCTAProps {
  label?: string
  size?: "default" | "lg" | "sm"
  className?: string
}

export function ServicePageCTA({ label = "Book a Discovery Call", size = "lg", className = "" }: ServicePageCTAProps) {
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact")
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" })
    } else {
      window.location.href = "/#contact"
    }
  }

  return (
    <Button
      onClick={scrollToContact}
      size={size}
      className={`hover:opacity-90 text-white font-semibold ${className}`}
      style={{ backgroundColor: "#ed2132" }}
    >
      {label}
      <ArrowRight className="ml-2 h-4 w-4" />
    </Button>
  )
}
